/** API Core */
export const corePlaylistByIdRoute = (playlistId: string) => `playlists/${playlistId}`;
export const coreProgramPlaylistByIdRoute = (playlistId: string) =>
  `playlists/${playlistId}/program`;
export const coreFollowsRoute = 'library/follows';
export const coreFolowDeleteRoute = (programUUID: string) => `library/follows/${programUUID}`;
